import { useForm } from "react-hook-form";
import { postApiSetting, stopTags, typeFloatNumber, typeNumber } from "../assets/functions";
import Navbar from "../components/Navbar";
import { ToastContainer, toast } from 'react-toastify';
import { NavLink,useNavigate } from "react-router-dom";
export default function PTPManualUpdate ({setAuth}) {

    const navigate = useNavigate();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const manuallyUpdateUTR = async (data) => {
        // console.log(data)
        let settings = postApiSetting({...data})
        try {
            let res = await fetch('/Admin/api/Admin/utrUpdateByRemark', settings);
            let result = (res.status === 200) ? await res.json(): "";
            console.log(res)
            console.log(result)
            if (res.status !== 200) {
                 if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            } else {
                if (result.data.responseCode === '00') {
                    alert('SUCCESS : ' + result.data.responseMsg)
                    reset();
                } else {
                    alert('FAILED : ' + result.data.responseMsg)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <section className="ptpmanual-page">
            <Navbar title="TRANSACTIONS" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">PTP MANUAL UPDATE</h6>
                    <form className="mb-4" onSubmit={handleSubmit(manuallyUpdateUTR)}>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="mb-2">
                                    <label className="form-label">Amount <strong className='text-danger'>*</strong></label>
                                    <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                        {...register('amount', { required: { value: true, message: "This field is required" } })} />
                                    {errors.amount && <strong className="text-danger"><small>{errors.amount.message}</small></strong>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="mb-2">
                                    <label className="form-label">Enter UTR <strong className='text-danger'>*</strong></label>
                                    <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                        {...register('utr', { required: { value: true, message: "This field is required" } })} />
                                    {errors.utr && <strong className="text-danger"><small>{errors.utr.message}</small></strong>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="mb-2">
                                    <label className="form-label">PTP Remark Id <strong className='text-danger'>*</strong></label>
                                    <input type="text" className="form-control shadow-none" onInput={stopTags}
                                        {...register('ptpRemarkId', { required: { value: true, message: "This field is required" } })} />
                                    {errors.ptpRemarkId && <strong className="text-danger"><small>{errors.ptpRemarkId.message}</small></strong>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label invisible">PTP Remark Id <strong className='text-danger'>*</strong></label>
                                <button type="submit" className="btn _themebg-0 text-white d-block">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </>)
}